import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles({
  layout: (props) => ({
    backgroundColor: 'transparent',
    color: 'inherit',
    overflow: 'auto',
    position: 'relative',
    height: props.height,
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
  }),
});

export default useStyle;
